import {createReducer} from '@reduxjs/toolkit'
import {Category} from '@wix/ambassador-wix-events-web/types'
import {reloadAllCategories} from '../actions/categories'

export interface CategoriesState {
  categories: Category[]
}

const defaultState: CategoriesState = {
  categories: [],
}

export const categories = createReducer(defaultState, builder => {
  builder.addCase(reloadAllCategories.fulfilled, (state, {payload}) => {
    state.categories = payload.categories as unknown as Category[]
  })
})
